import React from 'react';
import { sectors } from '../../data/sectors';
export function SectorsMarquee() {
  return <section aria-label="Secteurs accompagnés" className="border-b border-ink/10 bg-paper py-10" data-id="element-228" data-mp="l77cvthtilrt">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-6 px-5 sm:px-8 lg:flex-row lg:items-center lg:gap-12" data-id="element-229" data-mp="pxxklddpv0po">
        <p className="shrink-0 text-sm leading-relaxed text-muted lg:w-56" data-id="element-230" data-mp="uwh83i7ykkk5">
          Des missions menées dans plus de 10 secteurs d’activité
        </p>
        <div className="group relative flex min-w-0 flex-1 overflow-hidden" data-id="element-231" data-mp="3uf08nyej1ipy">
          {[0, 1].map(k => <ul key={k} aria-hidden={k === 1} className="flex shrink-0 animate-marquee items-center group-hover:[animation-play-state:paused]" data-id="element-232" data-mp="787pep61kcx8">
              {sectors.map(s => <li key={s.name} className="flex items-center whitespace-nowrap pr-10 text-xl font-medium text-ink/80" data-id="element-233" data-mp="1imbi7s0w7v0p">
                  {s.name}
                  <span className="ml-10 h-1.5 w-1.5 rounded-full bg-brass" aria-hidden="true" data-id="element-234" data-mp="1no0sv6k7e6o9" />
                </li>)}
            </ul>)}
        </div>
      </div>
    </section>;
}